import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import PayAndRegister from './PayAndRegister';

import {Actions as CREATEACCOUNTACTIONS} from '../../store/actions/createAccountActions';
import {Actions as PAYMENTACTIONS} from '../../store/actions/paymentActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';


function BestPriceCalculator({

  bundles,
  selectBundle,
  selectedBundle,
}) {

  const setBundleForPayment = (credits) => {

    selectBundle(bundles && bundles.find(b => b.credits == credits))
  }

  const [data, setData] = useState({
    noOfEmployees: "21-40"
  });

  let bestValue = 0
  let bestValueBonus = 0
  let recommendedBundle = 0
  let recommendedBundleBonus = 0
  let cashflowBundle = 0

  switch (data.noOfEmployees){
      case "1-5":
          bestValue = 100;
          recommendedBundle = 100;
          cashflowBundle = 100;
      case "6-10":
          bestValue = 100;
          recommendedBundle = 100;
          cashflowBundle = 100;
          break
      case "11-20":
          bestValue = 500;
          bestValueBonus = 30;
          recommendedBundleBonus = 10;
          recommendedBundle = 250;
          cashflowBundle = 100;
          break
      case "21-40":
          bestValue = 1000;
          bestValueBonus = 80;
          recommendedBundleBonus = 30;
          recommendedBundle = 500;
          cashflowBundle = 100;
          break
      case "41-80":
          bestValue = 2000;
          bestValueBonus = 220;
          recommendedBundleBonus = 80;
          recommendedBundle = 1000;
          cashflowBundle = 250;
          break
      case "81-200":
          bestValue = 2000;
          bestValueBonus = 220;
          recommendedBundleBonus = 220;
          recommendedBundle = 2000;
          cashflowBundle = 500;
          break
      case "200+":
          bestValue = 2000;
          bestValueBonus = 220;
          recommendedBundleBonus = 220;
          recommendedBundle = 2000;
          cashflowBundle = 500;
          break
  }


  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    })
  }

  if (selectedBundle){
    return <PayAndRegister/>
  }

  return (

    <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
      <div className="px-4 py-8 sm:px-10">

        <div className="mt-6">
          <form onSubmit={() => {}} className="space-y-6" id="PriceCalculator">
                
            <h2 className="text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl sm:leading-10">
              Price Calculator
            </h2>

            <div>
              <label htmlFor="noOfEmployees" className="sr-only">
                No of Employees
              </label>
              <div className="rounded-md shadow-sm">
                <select value={data.noOfEmployees} onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                  <option value="1-5">1-5 Employees</option>
                  <option value="6-10">6-10 Employees</option>
                  <option value="11-20">11-20 Employees</option>
                  <option value="21-40">21-40 Employees</option>
                  <option value="41-80">41-80 Employees</option>
                  <option value="81-200">81-200 Employees</option>
                  <option value="200+">200+ Employees</option>
                </select>
              </div>
            </div>


              <div className="grid grid-cols-4 gap-6">
                <div className="col-span-4 sm:col-span-2">
                   <h3 className="text-xl leading-9 font-extrabold tracking-tight sm:leading-10">
                    Best Deal
                  </h3>
                </div>

                <div className="col-span-4 sm:col-span-2 relative">
                  <button onClick={() => setBundleForPayment(bestValue)} type="button" className="flex-grow w-full bg-gray-800 border border-gray-800 rounded-md 5 py-2 text-sm leading-5 font-semibold text-white hover:bg-gray-700 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">{bestValue} Credits</button>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-200 text-green-800" style={{
                      right: "-14px",
                      position: "absolute",
                      transform: "rotate(25deg)",
                      top: "-5px",
                    }}>
                    + {(bestValueBonus/bestValue*100).toFixed(0)}%
                  </span>
                </div>

                <div className="col-span-4 sm:col-span-2">
                   <h3 className="text-xl leading-9 font-extrabold tracking-tight sm:leading-10">
                    Most Popular
                  </h3>
                </div>

                <div className="col-span-4 sm:col-span-2 relative">
                  <button onClick={() => setBundleForPayment(recommendedBundle)} type="button" className="flex-grow w-full bg-gray-800 border border-gray-800 rounded-md 5 py-2 text-sm leading-5 font-semibold text-white hover:bg-gray-700 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">{recommendedBundle} Credits</button>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-200 text-green-800" style={{
                      right: "-14px",
                      position: "absolute",
                      transform: "rotate(25deg)",
                      top: "-5px",
                    }}>
                    + {(recommendedBundleBonus/recommendedBundle*100).toFixed(0)}%
                  </span>
                </div>

                <div className="col-span-4 sm:col-span-2">
                   <h3 className="text-xl leading-9 font-extrabold tracking-tight sm:leading-10">
                    Best Cashflow
                  </h3>
                </div>

                <div className="col-span-4 sm:col-span-2">
                  <button onClick={() => setBundleForPayment(cashflowBundle)} type="button" className="flex-grow w-full bg-gray-800 border border-gray-800 rounded-md 5 py-2 text-sm leading-5 font-semibold text-white hover:bg-gray-700 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out">{cashflowBundle} Credits</button>
                </div>
              </div>

          </form>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <p className="text-xs leading-5 text-gray-500">Bundle recommendations are based on estimated credit usage over a 12 month period. <br/>To purchase larger amounts schedule a call with our team.</p>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const createAccount = state && state.createAccount

  return {
    creatingAccount: createAccount.creating,
    userCreated: createAccount.userCreated,
    userUpdated: createAccount.userUpdated,
    acLeadCreated: createAccount.acLeadCreated,
    demoAccountCreated: createAccount.demoAccountCreated,
    bundles: state.payment.bundles,
    selectedBundle: state.payment.selectedBundle,

  }
}

const mapDispatchToProps = dispatch => ({
  createAccount: (data) => dispatch(CREATEACCOUNTACTIONS.createAccount(data)),
  updateUserDetails: (data) => dispatch(CREATEACCOUNTACTIONS.updateUserDetails(data)),
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BestPriceCalculator) 
